import instanceQuery from 'graphql/queries/customer/CustomerAccountManagementGroupQuery.graphql';
import defaultQuery from 'graphql/queries/customer/CustomerAccountManagementGroupDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/CustomerAccountManagementGroupMutation.graphql';
import fragment from 'graphql/fragments/customer/CustomerAccountManagementGroup.graphql';
import workspaceQuery from 'graphql/queries/customer/CustomerAccountManagementGroupWorkspace.graphql';
import listQuery from 'graphql/queries/customer/CustomerAccountManagementGroupListQuery.graphql';

const CustomerAccountManagementGroup = {
  type: 'CustomerAccountManagementGroup',
  title: 'Customer Account Management Group',
  formTitle: 'Customer Account Management Group',
  formUrl: '/Customers/CustomerAccountManagementGroup/Details/',
  workspaceUrl: '/Customers/CustomerAccountManagementGroup/Workspace',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'ACCOUNT_MANAGEMENT_GROUP',
};

export default CustomerAccountManagementGroup;
